import { MARQUEE_WORDS } from "@/data/salon";

export const Marquee = () => {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section data-testid="editorial-marquee" className="border-y border-pink/20 bg-blush/60 py-6 overflow-x-clip">
      <div className="flex w-max animate-marquee">
        {items.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-3xl sm:text-4xl text-ink/40 px-8 whitespace-nowrap">{w}</span>
            <span className="text-pink text-2xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
